export default {
  open: 1,
  close: 2,
  ban: 3,
};